import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/lib/theme";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { Cards } from "@/pages/Cards";
import { Marketplace } from "@/pages/Marketplace";
import { CardDetail } from "@/pages/CardDetail";
import { Install } from "@/pages/Install";
import { TopMovers } from "@/pages/TopMovers";
import { Sell } from "@/pages/Sell";
import { Me } from "@/pages/Me";
import { Desirability } from "@/pages/Desirability";
import { Stats } from "@/pages/Stats";
import { ManualEntries, ManualEntryDetail } from "@/pages/ManualEntries";

export function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="cards" element={<Cards />} />
                <Route path="card/:id" element={<CardDetail />} />
                <Route path="marketplace" element={<Marketplace />} />
                <Route path="sell" element={<Sell />} />
                <Route path="me" element={<Me />} />
                <Route path="top-movers" element={<TopMovers />} />
                <Route path="desirability" element={<Desirability />} />
                <Route path="stats" element={<Stats />} />
                <Route path="install" element={<Install />} />
                <Route path="manual-entries" element={<ManualEntries />} />
                <Route path="manual-entries/:id" element={<ManualEntryDetail />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
